import { render, staticRenderFns } from "./CreateCacaoTree.vue?vue&type=template&id=7327712a"
import script from "./CreateCacaoTree.vue?vue&type=script&lang=js"
export * from "./CreateCacaoTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports